import { Theme } from '@mui/material/styles';
import { IconChevronDown } from 'src/libraries/icons';

// ----------------------------------------------------------------------

export default function Autocomplete(theme: Theme) {
  return {
    MuiAutocomplete: {
      defaultProps: {
        popupIcon: <IconChevronDown size={22} />
      },
      styleOverrides: {
        root: {
          '& svg': {
            color: theme?.palette?.branded?.carbon,
          },
        },
        paper: {
          // option list styles
          // border: `1px solid ${theme.palette.grey[300]} !important`,
          borderRadius: 0,
        },
        option: {

        },
        listbox: {
          padding: theme.spacing(0),
          "& .MuiAutocomplete-option[aria-selected='true']": {
            backgroundColor: "transparent !important",
          },
          '& .MuiAutocomplete-option:hover': {
            color: theme.palette.primary.main,
            backgroundColor: "transparent !important",
          },
          '&::-webkit-scrollbar': {
            width: '6px !important'
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1 !important'
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888 !important',
            borderRadius: '6px !important',
          },
          '& ::-webkit-scrollbar-thumb:hover': {
            background: '#777 !important'
          },
        },
      },
    },
  };
}
